import Main from '@/views/common/main'
// 风控
export default [
    //'风控管理'
    {
        path: '/syncManager',
        name: 'syncManager',
        meta: {
            icon: 'ios-apps',
            title: '同步管理'
        },
        component: Main,
        children: [
            // 游戏策略库配置
            {
                path: 'configSync',
                name: 'syncment_configSync',
                meta: { title: '配置同步' },
                component: () => import('@/views/syncment/configSync.vue')
            }
        ]
    }
]
// 数据报表
